module.exports = __webpack_public_path__ + "static/media/flute.276600ad.jpg";